import React, { FC } from 'react';
import { Box, CssBaseline, Grid } from '@material-ui/core';
import Backdrop from '../components/backdrop';
import { NotificationsContextProvider } from '../providers/NotificationsProvider';
import TransitionProvider from '../providers/TransitionProvider';
import ErrorBoundary from '../components/error-boundary/ErrorBoundary';
import { Navigation } from '../components/installer-portal/navigation';
import TranslationLoader from '../components/translation-loader/TranslationLoader';
import Notifications from '../components/notifications';
import InstallerSessionTimeout from '../components/installer-portal/InstallerSessionTimeout';
import mainColors from '../themes/main-colors';
import PathProvider from '../providers/PathProvider';
import PromotionProvider from '../providers/PromotionProvider';
import { ThemeProvider } from '../providers/ThemeProvider';

interface Props {
  readonly element: any;
  readonly props: Readonly<{
    pageContext: Record<string, any>;
    pageResources: Record<string, any>;
    location: Record<string, any>;
  }>;
}

const wrapPageElement: FC<Props> = ({
  element,
  props: { pageContext, pageResources },
}) => {
  const renderPageComponents = () => (
    <Box
      id={'full-height-shim'}
      display={'flex'}
      flexDirection={'column'}
      minHeight="100vh"
    >
      <Box id="pge-header">
        <Navigation />
      </Box>
      <Box id="global-notifications-banner">
        <Notifications />
      </Box>
      <Box flexGrow={1}>{element}</Box>
      <Backdrop />
      <Box>
        <Grid
          style={{
            marginTop: '20px',
            position: 'static',
            left: 0,
            bottom: 0,
            width: '100%',
            height: '85px',
            backgroundColor: mainColors.noirBlur,
            color: mainColors.white,
          }}
        />
      </Box>
    </Box>
  );
  return (
    <ThemeProvider>
      <TransitionProvider>
        <NotificationsContextProvider>
          <PromotionProvider context={{ ...pageContext, ...pageResources }}>
            <PathProvider context={pageContext.slugPathMap}>
              <CssBaseline />
              <TranslationLoader />
              <ErrorBoundary>
                <InstallerSessionTimeout />
                {renderPageComponents()}
              </ErrorBoundary>
            </PathProvider>
          </PromotionProvider>
        </NotificationsContextProvider>
      </TransitionProvider>
    </ThemeProvider>
  );
};

export default wrapPageElement;
